"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.FormContext = react_1.default.createContext({});
exports.default = exports.FormContext;
//# sourceMappingURL=FormContext.js.map